import angular from "angular";

angular
    .module('app')
    .component('courseAnswers', {
        template: require('./course-answers.html'),
        controller: ['$http', 'Notifier', controller],
        bindings: {
            course: '<',
            answers: '<',
        }
    });

function controller($http, Notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

    };

    $ctrl.submit = function (answer) {

        let params = {
            status: answer.status,
            result: answer.result,
        };

        $http.post('/admin/answer/' + answer.id + '/response', params).then(function (response) {
            Notifier.success('Ответ успешно отправлен', 3)
        })
    }
}
